import { DataRequestProject } from '../models/DataRequestHub/DataRequestProject';
import { ProjectProgressStatus } from '../models/DataRequestHub/ProjectProgressStatusEnum copy';
import { TimelineParty } from '../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { useCurrentMarketplaceParty } from './useCurrentMarketplaceParty';

export const useIsDataRequestProjectReadonly = (
    projects: DataRequestProject[]
): boolean => {
    const isReadonlyForExternalUsers =
        useCurrentMarketplaceParty() === TimelineParty.Broker;
    return (
        (projects.length > 0 &&
            projects.every(
                (project) =>
                    project?.isExternalProject &&
                    project?.status === ProjectProgressStatus.Complete
            )) ||
        isReadonlyForExternalUsers
    );
};
